var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 10,
    viewBox: "0 0 19 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.876577 9.63388C1.37868 10.122 2.19275 10.122 2.69485 9.63388L9.5 3.01777L16.3051 9.63388C16.8073 10.122 17.6213 10.122 18.1234 9.63388C18.6255 9.14573 18.6255 8.35427 18.1234 7.86612L10.4091 0.366117C9.90703 -0.122039 9.09297 -0.122039 8.59086 0.366117L0.876577 7.86612C0.374474 8.35427 0.374474 9.14573 0.876577 9.63388Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.6bb093f9f1a98ab10e99b8097837ea9b.svg";
export { ForwardRef as ReactComponent };